import Color from "../../enum/Color";
import { HexColor } from "../../types/AnyColor";

export const colorsToHex: Record<Color, string> = {
  black: "#464646",
  blue: "#4a90e2",
  brown: "#cb0303",
  cyan: "#00ffff",
  gold: "#daa520",
  green: "#32cd32",
  grey: "#acacac",
  maroon: "#aa133f",
  navy: "#000080",
  "neon blue": "#4d4dff",
  "neon green": "#aeff14",
  "neon purple": "#ea6fff",
  "neon red": "#ff0000",
  "neon yellow": "#f3f315",
  olive: "#556b2f",
  orange: "#ff6f1b",
  peach: "#ffdab9",
  pink: "#ff6f9c",
  purple: "#b549a2",
  red: "#ff5d6c",
  teal: "#008080",
  turquoise: "#40e0d0",
  violet: "#951ce4",
  white: "#ffffff",
  yellow: "#ffa700",
} as const;

const colorNameToHex = (color: Color): HexColor => colorsToHex[color] as HexColor;

export default colorNameToHex;
